import {
  OreCardContainer,
  OreCardWrapper,
  OreDivider,
  OreStack,
  OreText,
} from '@edenredespana/oreneta'
import { FormProvider, UseFormReturn } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import {
  ContractNewProductsStep2Actions,
  ContractNewProductsStep2Form,
} from '@/Contract/ui/atoms'
import { useContractNewProducts } from '@/Contract/ui/context'
import { Step2Form } from '@/Contract/ui/hooks'
import { ProtectedWrapper } from '@/Shared/ui/navigation'
import { formTranslation } from '@/Shared/ui/sharedTranslation'

export const ContractNewProductsStep2 = (): JSX.Element => {
  const { t } = useTranslation()

  const { getCurrentStepForm, autoEnrollmentModel } = useContractNewProducts()

  const form = getCurrentStepForm() as UseFormReturn<Step2Form>

  return (
    <ProtectedWrapper>
      <FormProvider {...form}>
        <form>
          <OreStack placeContent="stretch" space="large">
            <OreCardContainer>
              <OreCardWrapper>
                <OreStack placeContent="stretch" space="xlarge">
                  <ContractNewProductsStep2Form
                    isEditable={autoEnrollmentModel?.billingOwnerData?.isEditable ?? true}
                    isDocumentEditable={
                      autoEnrollmentModel?.billingOwnerData?.isDocumentEditable ?? true
                    }
                  />
                  <OreText>{t(formTranslation.common.requiredFields)}</OreText>
                </OreStack>
              </OreCardWrapper>
            </OreCardContainer>
            <OreDivider space="medium" />
            <ContractNewProductsStep2Actions
              isEditable={autoEnrollmentModel?.billingOwnerData?.isEditable ?? true}
              isDocumentEditable={
                autoEnrollmentModel?.billingOwnerData?.isDocumentEditable ?? true
              }
            />
          </OreStack>
        </form>
      </FormProvider>
    </ProtectedWrapper>
  )
}
